"use client";

import { useEffect, useState } from "react";
import Icon from "@/components/ui/AppIcon";

export default function CTASection() {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -5% 0px" }
    );

    document.querySelectorAll(".animate-on-scroll").forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic here
  };

  return (
    <section className="py-32 px-6 sm:px-12 relative overflow-hidden border-t border-white/5">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/10 blur-[120px] rounded-full pointer-events-none"></div>

      <div className="max-w-2xl mx-auto text-center relative z-10 animate-on-scroll [animation:animationIn_0.8s_ease-out_0.2s_both]">
        <h2 className="text-5xl font-display font-medium tracking-tight text-white mb-6">
          Ready to Create Something Extraordinary?
        </h2>
        <p className="text-muted-foreground font-light text-lg mb-10 leading-relaxed">
          Let's discuss your next production. Whether it's film, television, or live events, we're here to bring your vision to life.
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <input
              type="text"
              placeholder="Your Name"
              className="w-full h-14 bg-white/5 border border-white/10 rounded-xl px-5 text-white placeholder-muted-foreground focus:outline-none focus:border-primary/50 focus:ring-1 focus:ring-primary/50 transition-all font-light"
              required
            />
            <input
              type="email"
              placeholder="Email Address"
              className="w-full h-14 bg-white/5 border border-white/10 rounded-xl px-5 text-white placeholder-muted-foreground focus:outline-none focus:border-primary/50 focus:ring-1 focus:ring-primary/50 transition-all font-light"
              required
            />
          </div>
          <select
            className="w-full h-14 bg-white/5 border border-white/10 rounded-xl px-5 text-white focus:outline-none focus:border-primary/50 focus:ring-1 focus:ring-primary/50 transition-all font-light"
            required
          >
            <option value="" className="bg-card text-muted-foreground">
              Project Type
            </option>
            <option value="film" className="bg-card text-white">
              Film Production
            </option>
            <option value="event" className="bg-card text-white">
              Event Management
            </option>
            <option value="post" className="bg-card text-white">
              Post-Production
            </option>
            <option value="other" className="bg-card text-white">
              Other
            </option>
          </select>
          <textarea
            placeholder="Tell us about your project..."
            rows={4}
            className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-4 text-white placeholder-muted-foreground focus:outline-none focus:border-primary/50 focus:ring-1 focus:ring-primary/50 transition-all font-light resize-none"
            required
          ></textarea>
          <button
            type="submit"
            className="h-14 bg-gradient-to-r from-primary to-red-800 text-white font-medium rounded-xl hover:shadow-lg transition-all duration-300 glow-primary hover:glow-primary-hover flex items-center justify-center gap-2"
          >
            <Icon name="PaperAirplaneIcon" size={20} />
            Send Message
          </button>
        </form>

        <p className="text-muted-foreground text-xs mt-4">
          We respond within 24 hours. Your information is secure and confidential.
        </p>
      </div>
    </section>
  );
}